/**
 * useSendMessage Hook
 *
 * Generic hook for sending platform messages with loading state and error handling.
 */
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { sendMessage, SendMessageRequest } from 'shared/api';

type UseSendMessageOptions<TRequest extends SendMessageRequest> = Omit<
    UseMutationOptions<void, Error, TRequest>,
    'mutationFn'
>;

export default function useSendMessage<TRequest extends SendMessageRequest = SendMessageRequest>(
    options?: UseSendMessageOptions<TRequest>
) {
    return useMutation({
        mutationFn: (data: TRequest) => sendMessage(data as SendMessageRequest),
        ...options
    });
}
